// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__121fl","newExpiryDate":"styles_newExpiryDate__2n0ai","footer":"styles_footer__t2Pt7"};